# hii :3

first post!!! git-based blogging system go brrrr

honestly really liking sveltekit so far, its like. really convenient and pretty easy to work with. anyway. merry christmas!!!

![festive :3 cat](/festive_colon_3.jpg)

_2022-12-25_

<style>
	img {
		height: 5em;
	}
</style>
